import { MaskedContact, RecoverAccountResponse } from '../../slices/auth-api.slice';
import { emailContact } from './contacts';

export const maskedContact: MaskedContact = {
    contacts: [emailContact],
    authenticatorEnabled: false
};

export const recoverAccountOutput: RecoverAccountResponse = {
    isVcrEnvironment: false,
    maskedContact: maskedContact
};

export const isVcrEnvironmentRecoverAccountOutput: RecoverAccountResponse = {
    isVcrEnvironment: true,
    maskedContact: maskedContact
};
